export default "__VITE_ASSET__FzGsT6BM__"